<template lang="pug">
.zoom-slider
  .out(@click.stop.prevent="emit('update:modelValue', Math.max(0, modelValue - 25))")
    Icon.out-icon(:name="leftIcon || 'search'")
  .slider(@mousedown.stop.prevent="start" @touchstart.stop.prevent="start" :class="{dragging: dragging}")
    .slider-bar(ref="sliderBar")
      .slider-bar-complete(:style="{width: Math.min(100, Math.max(1, modelValue)) + '%'}")
    .circle(:style="{left: Math.min(100, modelValue) + '%'}")
  .in(@click.stop.prevent="emit('update:modelValue', Math.min(100, modelValue + 25))")
    Icon.in-icon(:name="rightIcon || 'search'")
</template>
<script setup lang="ts">
import { ref, nextTick } from 'vue'

const emit = defineEmits<{'update:modelValue': [val: number]}>()

defineProps<{modelValue: number, leftIcon?:string, rightIcon?: string }>()

const dragging = ref(false)

const sliderBar = ref<HTMLElement>()

function updateFromPosition(e:MouseEvent | TouchEvent) {
  const el = sliderBar.value
  if (!el) {
    return
  }
  const box = el.getBoundingClientRect()
  let left = -box.left
  if (e instanceof TouchEvent) {
    left += e.touches[0].clientX
  } else {
    left += e.clientX
  }

  left = Math.max(0, Math.min(box.width, left))

  const pct = left / box.width

  emit('update:modelValue', pct * 100)
}

function listener(e: MouseEvent | TouchEvent) {
  updateFromPosition(e)
}
function end() {
  window.removeEventListener('mousemove', listener)
  window.removeEventListener('touchmove', listener)
  window.removeEventListener('touchend', end)
  window.removeEventListener('mouseup', end)
  nextTick(() => dragging.value = false)
}

function start(e: MouseEvent) {
  dragging.value = true
  updateFromPosition(e)
  window.addEventListener('mousemove', listener)
  window.addEventListener('touchmove', listener)
  window.addEventListener('mouseup', end)
  window.addEventListener('touchend', end)
}

</script>
<style lang="scss" scoped>
.zoom-slider {
  display: flex;
  align-items: center;
  z-index: 2;
  user-select: none; /* Standard syntax */
}

.out-icon {
  width: 14px;
  height: 14px;
  filter: drop-shadow(1px 0 0 white) drop-shadow(-1px 0 0 white) drop-shadow(0 1px 0 white) drop-shadow(0 -1px 0 white);
}

.out, .in {
  width: 36px;
  height: 30px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  cursor: pointer;
}

.out {
  margin-right: 12px;
}
.in {
  margin-left: 12px;
}

.in-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  filter: drop-shadow(1px 0 0 white) drop-shadow(-1px 0 0 white) drop-shadow(0 1px 0 white) drop-shadow(0 -1px 0 white);
}

.slider {
  flex-grow: 1;
  position: relative;
  cursor: pointer;

  &.dragging {
    cursor: grabbing;
  }
}

.slider-bar {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background-color: $color-gray-dark;
  box-shadow: 0 0 0 2px white;
}

.slider-bar-complete {
  background-color: black;
  height:  8px;
  pointer-events: none;
  border-radius: 4px;
  width: 20%;
}

.circle {
  background-color: $color-black;
  width: 14px;
  height: 14px;
  border-radius: 7px;
  cursor: pointer;
  pointer-events: none;
  top: -3px;
  position: absolute;
  margin-left: -7px;
  box-shadow: 0 0 0 2px white;
}
</style>
